import React, { Component } from "react";
import PinInput from "react-pin-input";
import "./InputPinCode.scss";

class InputPinCode extends Component {
	constructor(props) {
		super(props);
		this.state = {
			defaultCountry: "br",
			value: "12345",
			pin: "",
		};
	}

	handleOnChange = (value, idx) => {
		this.setState({ pin: value });
	};

	handleOnSubmit = (code) => {
		this.setState({ pin: code });
	};

	render() {
		const { onSubmit, useNewLayoutCheckout, error, newLayout, onChangePin } = this.props;
		let stylesInput = { borderColor: "#206020" };
		let style = { padding: "5px" };

		if (useNewLayoutCheckout) {
			stylesInput = { width: 43, height: 52, borderColor: "#000000" };
			style = {};
		}

		if (newLayout) {
			let colorBorder = error ? "#D30D48" : "#353546";
			let width = window.innerWidth <= 900 ? 54 : 59;
			stylesInput = {
				width: width,
				height: 56,
				borderWidth: 2,
				borderColor: colorBorder,
				borderRadius: "8px",
				color: "#FFFF",
				fontFamily: "MetropolisRegular",
			};
			style = {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				marginBottom: "4px",
				width: "100%",
			};
		}

		return (
			<PinInput
				length={6}
				initialValue=""
				focus
				onChange={(value, index) => {
					this.handleOnChange(value, index);
					if (newLayout) {
						onChangePin();
					}
				}}
				type="numeric"
				inputMode="number"
				style={style}
				inputStyle={stylesInput}
				onComplete={(code) => onSubmit(code)}
				autoSelect={false}
			/>
		);
	}
}

export default InputPinCode;
